import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionValuesComponent } from './component/section-values.component';



@NgModule({
  declarations: [SectionValuesComponent],
  imports: [
    CommonModule
  ],
  exports: [
    SectionValuesComponent
  ]
})
export class SectionValuesModule { }
